export const radii: Record<string, string> = {
  Q: '1rem 1rem 1rem 0',
};
